import { useAtomValue } from "jotai"
import { useLocation, useNavigate } from "react-router-dom"
import { teamsAtom } from "../../stores/jotai/teams/teams"
import { useQueryClient } from "@tanstack/react-query"
import { baseAtom } from "../../stores/jotai/base"

export const withRouter = (Component: any) => (props: any) => {
    const navigate = useNavigate()
    const location = useLocation()
    const teamsData=useAtomValue(teamsAtom);
    const client = useQueryClient()
    const base = useAtomValue(baseAtom);

    const customFindingTypesData = client.getQueryData(["custom-finding-types", { groupID: base?.team?.groupID }]);

    return <Component {...props} {...{ navigate, location,teamsData, customFindingTypes: customFindingTypesData }} />
}